(() => {
  function init() {
    document.querySelectorAll('[data-caldris]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const q = selector => root.querySelector(selector);
      const all = selector => [...root.querySelectorAll(selector)];
      const product = JSON.parse(q('[data-product-json]').textContent || 'null');
      const french = root.dataset.language === 'fr';
      const translations = JSON.parse(q('[data-caldris-i18n]').textContent);
      const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{'+name+'}', value), translations[key]);
      const money = value => new Intl.NumberFormat(french ? 'fr-FR' : 'en-US', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(value / 100);
      const buyPanel = q('.cal-buy');
      // Let tall purchase panels scroll fully before following the gallery.
      const updateStickyPanel = () => {
        const top = Math.min(24, window.innerHeight - buyPanel.offsetHeight - 100);
        buyPanel.style.setProperty('--cal-buy-sticky-top', `${top}px`);
      };
      new ResizeObserver(updateStickyPanel).observe(buyPanel);
      window.addEventListener('resize', updateStickyPanel, { passive: true });
      updateStickyPanel();
      all('[data-image]').forEach(button => button.addEventListener('click', () => {
        q('#cal-main-image').src = button.dataset.image;
        q('#cal-main-image').alt = button.querySelector('img').alt;
        if (q('[data-gallery-caption]')) {
          q('[data-gallery-caption]').textContent = button.dataset.caption || '';
          q('[data-gallery-caption]').hidden = !button.dataset.caption;
          q('.cal-main-image').dataset.galleryTone = button.dataset.galleryTone;
        }
        all('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      all('[data-photo-carousel]').forEach(carousel => {
        const toggle = carousel.querySelector('[data-photo-toggle]');
        carousel.dataset.paused = 'false';
        carousel.dataset.visible = 'false';
        toggle.addEventListener('click', () => {
          const paused = carousel.dataset.paused !== 'true';
          carousel.dataset.paused = String(paused);
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.textContent = paused ? t('play_photos') : t('pause_photos');
        });
        const visibility = new IntersectionObserver(entries => {
          if (!carousel.isConnected) { visibility.disconnect(); return; }
          carousel.dataset.visible = String(entries[0].isIntersecting);
        });
        visibility.observe(carousel);
        const syncPage = () => {
          if (!carousel.isConnected) { document.removeEventListener('visibilitychange', syncPage); visibility.disconnect(); return; }
          carousel.dataset.pageHidden = String(document.hidden);
        };
        document.addEventListener('visibilitychange', syncPage);
        syncPage();
      });
      let lastDay;
      const updateDelivery = () => {
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const part = name => Number(parts.find(p => p.type === name).value);
        const day = Date.UTC(part('year'), part('month') - 1, part('day'));
        all('[data-recent-orders-until]').forEach(el => { el.hidden = Date.now() >= Number(el.dataset.recentOrdersUntil) * 1000; });
        if (day === lastDay) return;
        lastDay = day;
        const shortDate = offset => new Intl.DateTimeFormat(french ? 'fr-FR' : 'en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(new Date(day + offset * 86400000));
        all('[data-timeline-date]').forEach(el => { el.textContent = el.dataset.timelineDate.split(',').map(Number).map(shortDate).join(' – '); });
      };
      updateDelivery();
      const deliveryTimer = setInterval(() => { if (!root.isConnected) clearInterval(deliveryTimer); else updateDelivery(); }, 60000);
      if (!product?.variants?.length) return;
      // Keep variant matching stable when Shopify localizes option values.
      const canonicalOption = value => ({
        '1 sweat': '1 Hoodie',
        '1 sweat + batterie': '1 Hoodie + Power Bank',
        'Pack Duo + 2 batteries': 'Duo + 2 Power Banks',
        'Non incluse': 'Not included'
      }[value] || value?.replace(/^Gris \/ /, 'Grey / ').replace(/^Noir \/ /, 'Black / '));
      product.variants.forEach(variant => {
        ['option1', 'option2', 'option3'].forEach(key => { variant[key] = canonicalOption(variant[key]); });
      });
      const base = product.variants.find(v => v.option1 === '1 Hoodie');
      const battery = product.variants.find(v => v.option1 === '1 Hoodie + Power Bank');
      const duo = product.variants.find(v => v.option1 === 'Duo + 2 Power Banks');
      const findVariant = (pack, colour, size, second = 'Not included') => product.variants.find(v => v.option1 === pack && v.option2 === `${colour} / ${size}` && v.option3 === second);
      q('[data-single-price]').textContent = money(base.price);
      q('[data-duo-price]').textContent = money(duo.price);
      const referencePrice = Math.round(base.price * 7995 / 5990);
      q('[data-single-compare]').textContent = money(referencePrice);
      q('[data-single-saving]').textContent = t('save_amount', {amount:money(referencePrice - base.price)});
      q('[data-duo-compare]').textContent = money(base.price * 2);
      q('[data-duo-basis]').textContent = french ? 'Soit 2 × ' + money(base.price) + ' à l’unité' : 'Based on 2 × ' + money(base.price) + ' individually';
      q('[data-duo-each]').textContent = t('each_price', {amount:money(Math.round(duo.price / 2))});
      all('[data-battery-price],[data-quick-battery-price]').forEach(el => { el.textContent = battery && base && battery.price > base.price ? money(battery.price - base.price) : '[[PRIX_BATTERIE]]'; });
      let addingMain = false;
      const update = () => {
        const isDuo = q('[name="cal-offer"]:checked').value === 'duo';
        const destination = q(`[data-offer-details="${isDuo ? 'duo' : 'single'}"]`);
        const selection = q('[data-pack-selection]');
        if (selection.parentElement !== destination) destination.append(selection);
        all('[data-offer-card]').forEach(card => { card.classList.toggle('is-selected', card.dataset.offerCard === (isDuo ? 'duo' : 'single')); });
        q('[data-jacket-row="2"]').hidden = !isDuo;
        q('[data-battery-row]').hidden = isDuo;
        const pack = isDuo ? 'Duo + 2 Power Banks' : q('[data-battery]').checked ? '1 Hoodie + Power Bank' : '1 Hoodie';
        const second = isDuo ? `${q('[data-colour="2"]').value} / ${q('[data-size="2"]').value}` : 'Not included';
        const variant = findVariant(pack, q('[data-colour="1"]').value, q('[data-size="1"]').value, second);
        q('[data-variant-id]').value = variant?.id || '';
        q('[data-add]').disabled = addingMain || !variant?.available;
        q('[data-add]').textContent = addingMain ? t('adding') : variant?.available ? t('add_to_cart') : t('unavailable');
        q('[data-battery-note]').textContent = isDuo ? t('includes_two_jackets_and_two_free_usb_power_banks_choos') : q('[data-battery]').checked ? t('includes_one_jacket_and_one_usb_power_bank') : t('one_jacket_does_not_include_a_power_bank_use_your_own_c');
      };
      all('#cal-product-form select,[name="cal-offer"],[data-battery]').forEach(el => el.addEventListener('change', update));
      const selected = product.variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant'));
      if (selected) {
        q(`[name="cal-offer"][value="${selected.option1.startsWith('Duo') ? 'duo' : 'single'}"]`).checked = true;
        q('[data-battery]').checked = selected.option1 === '1 Hoodie + Power Bank';
        [selected.option2, selected.option3].forEach((value, index) => {
          if (value === 'Not included') return;
          const [colour, size] = value.split(' / ');
          q(`[data-colour="${index + 1}"]`).value = colour;
          q(`[data-size="${index + 1}"]`).value = size;
        });
      }
      update();
      const add = async id => {
        if (!id) throw Error(t('please_choose_an_available_size'));
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: ['cart-drawer','cart-icon-bubble'], sections_url: location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw Error(result.description || t('unable_to_add_this_item_please_try_again'));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && result.sections?.['cart-drawer']) { drawer.classList.remove('is-empty'); drawer.setActiveElement(document.activeElement); drawer.renderContents(result); }
        else location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      };
      q('#cal-product-form').addEventListener('submit', async event => {
        event.preventDefault();
        if (addingMain) return;
        const id = q('[data-variant-id]').value;
        addingMain = true; update(); q('[data-status]').textContent = '';
        try { await add(id); } catch (error) { q('[data-status]').textContent = error.message; } finally { addingMain = false; update(); }
      });
      const quick = q('[data-quick-form]');
      if (quick) {
        let addingQuick = false;
        const updateQuick = () => {
          const variant = product.variants.find(v => String(v.id) === q('[data-quick-choice]').value);
          q('[data-quick-variant]').value = variant?.id || '';
          q('[data-quick-add]').disabled = addingQuick || !variant?.available;
          q('[data-quick-add]').textContent = addingQuick ? t('adding') : variant?.available ? t('add_to_cart') : t('unavailable');
          if (variant) q('[data-quick-price]').textContent = money(variant.price);
        };
        quick.querySelectorAll('select,input[type="checkbox"]').forEach(el => el.addEventListener('change', updateQuick));
        quick.addEventListener('submit', async event => {
          event.preventDefault();
          if (addingQuick) return;
          const id = q('[data-quick-variant]').value;
          addingQuick = true; updateQuick(); q('[data-quick-status]').textContent = '';
          try { await add(id); } catch (error) { q('[data-quick-status]').textContent = error.message; } finally { addingQuick = false; updateQuick(); }
        });
        updateQuick();
      }
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
